module.exports = __webpack_public_path__ + "static/media/evault-with-screen.20d2472e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evault-with-screen.jpg
// module id = 1020
// module chunks = 0